import React from 'react';
import PropTypes from 'prop-types';

const TITLE_SEP = ' · ';

export const splitAccountTitle = (title) => {
  const idx = title.indexOf(TITLE_SEP);
  if (idx === -1) {
    return { nickname: title, bank: null };
  }
  return {
    nickname: title.slice(0, idx),
    bank: title.slice(idx + TITLE_SEP.length),
  };
};

/**
 * "Nickname · Bank" — nickname bold, bank name lighter weight.
 */
const AccountTitleDisplay = ({ title, as: Component = 'span', className = '', id }) => {
  const { nickname, bank } = splitAccountTitle(title);
  return (
    <Component id={id} className={`requirements-bank-card-title ${className}`.trim()}>
      <span className="requirements-bank-card-nickname">{nickname}</span>
      {bank && (
        <>
          <span className="requirements-bank-card-title-sep"> · </span>
          <span className="requirements-bank-card-bank">{bank}</span>
        </>
      )}
    </Component>
  );
};

AccountTitleDisplay.propTypes = {
  title: PropTypes.string.isRequired,
  as: PropTypes.elementType,
  className: PropTypes.string,
  id: PropTypes.string,
};

export default AccountTitleDisplay;
